/*
 * CHPO split swatches.
 * Reads the colour groups Swatch King publishes for this store
 * (window.starapps_data.product_groups) and renders split frame/lens circles
 * that link to each sibling product. Groups are still managed in Swatch King.
 *
 * Usage: <chpo-swatches data-handle="henrik-black-sunglasses-16132pb" data-variant="pdp|card" data-max="4"></chpo-swatches>
 */
(function () {
  if (customElements.get('chpo-swatches')) return;

  var DATA_URL = 'https://cdn.starapps.studio/apps/vsk/chpo-brand/data.js';

  // Colour names used in Swatch King option values, mapped to a representative hex.
  var COLOURS = {
    'black': '#1e1c1b', 'matte black': '#2a2827', 'black gradient': '#3b3938', 'brown': '#6e4a33',
    'light brown': '#9a6b45', 'funky brown': '#8a5a2b', 'transparent': '#e9e7e4', 'transparent grey': '#bdbab8',
    'transparent olive': '#a8a77a', 'transparent blue': '#a9c3d6', 'white': '#ffffff', 'cream': '#efe6d2',
    'green': '#55705a', 'forest green': '#2f4a35', 'moss green': '#6b7a4a', 'army green': '#4b5a3a',
    'disco green': '#3fb47a', 'green camo': '#5c6b45', 'swedish forest': '#2f4a35', 'olive': '#6f6d3d',
    'mint': '#bfe3cf', 'gold': '#c9a85a', 'gold mirror': '#d9b35a', 'rose gold': '#d8a48f', 'champagne': '#e3d1ad',
    'grey': '#6b6e70', 'matte grey': '#7a7c7e', 'grey turtle': '#7b736b', 'turtle grey': '#7b736b',
    'silver': '#c4c6c8', 'silver mirror': '#d2d6da', 'swedish metal': '#9ea3a8', 'gunmetal': '#4a4d50',
    'navy metal': '#2e3a55', 'turtle brown': '#7a4a25', 'turtle amber': '#a8642c', 'black & white turtle': '#8c8885',
    'leopard': '#8a5a2b', 'mustard': '#d4a62a', 'custard': '#e8cf7a', 'lemon': '#f0dc5a', 'yellow': '#f2c94c',
    'amber': '#c98a2b', 'cola': '#5a2e1e', 'cigar smoke': '#5e4f45', 'red mirror': '#f0662e',
    'coral mirror': '#f2795a', 'copper mirror': '#c8743f', 'copper mirrror': '#c8743f', 'apricot': '#f2b38a',
    'apricot mirror': '#f2a06b', 'orange': '#f08a2e', 'peach': '#f5c3a5', 'pink': '#f2b6c6', 'pink mirror': '#f08fb2',
    'blue mirror': '#3b78c4', 'blue': '#3e64a8', 'light blue': '#a9c9e8', 'navy': '#25314d', 'dark navy': '#1b2438',
    'indigo': '#3d3f8f', 'turquoise': '#3fb8b0', 'turquoise mirror': '#33b5c9', 'rainbow mirror': '#9b7fd1',
    'purple': '#6b4a8f', 'purple mirror': '#8a5ad1', 'purple gradient': '#7a5a9a', 'infra purple': '#6a3fa0',
    'elderflower': '#e9e1c4', 'burgundy': '#7a2a2e', 'multi': '#b98a5a', 'photochromic': '#9aa3a8',
    'green mirror': '#4fb36b', 'betong': '#9c9a95', 'sand': '#d8c7a6'
  };
  var FALLBACK = '#bdbab8';

  function colourFor(name) {
    return COLOURS[(name || '').trim().toLowerCase()] || FALLBACK;
  }

  var dataPromise = null;
  function loadData() {
    if (window.starapps_data && window.starapps_data.product_groups) return Promise.resolve(window.starapps_data);
    if (dataPromise) return dataPromise;
    dataPromise = new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = DATA_URL;
      s.async = true;
      s.onload = function () { resolve(window.starapps_data || null); };
      s.onerror = function () { resolve(null); };
      document.head.appendChild(s);
    });
    return dataPromise;
  }

  function findGroup(data, handle) {
    if (!data || !data.product_groups) return null;
    var groups = data.product_groups;
    for (var i = 0; i < groups.length; i++) {
      var vals = groups[i].option_values || [];
      for (var j = 0; j < vals.length; j++) if (vals[j].handle === handle) return groups[i];
    }
    return null;
  }

  function splitSvg(frame, lens, selected, soldOut) {
    var f = colourFor(frame), l = colourFor(lens || frame);
    var ring = selected ? '<circle cx="22" cy="22" r="21" fill="none" stroke="#302C2B" stroke-width="1.5"/>' : '';
    var edge = '<circle cx="22" cy="22" r="16" fill="none" stroke="#E4E2E1" stroke-width="1"/>';
    var slash = soldOut ? '<line x1="10" y1="34" x2="34" y2="10" stroke="#6C6C6C" stroke-width="1.5"/>' : '';
    var op = soldOut ? ' fill-opacity="0.45"' : '';
    return '<svg viewBox="0 0 44 44" aria-hidden="true" focusable="false">' + ring +
      '<path d="M22 6 A16 16 0 0 0 10.69 33.31 L33.31 10.69 A16 16 0 0 0 22 6Z" fill="' + f + '"' + op + '/>' +
      '<path d="M33.31 10.69 L10.69 33.31 A16 16 0 0 0 33.31 10.69Z" fill="' + l + '"' + op + '/>' +
      edge + slash + '</svg>';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  class ChpoSwatches extends HTMLElement {
    connectedCallback() {
      if (this._done) return;
      this._done = true;
      var self = this;
      var handle = this.dataset.handle;
      if (!handle) return;
      loadData().then(function (data) {
        var group = findGroup(data, handle);
        if (!group) { self.hidden = true; return; }
        self.render(group, handle);
      });
    }

    render(group, handle) {
      var isPdp = this.dataset.variant === 'pdp';
      var max = parseInt(this.dataset.max || (isPdp ? '99' : '4'), 10);
      var values = (group.option_values || []).filter(function (v) { return v.published !== false; });
      if (values.length < 2 && !isPdp) { this.hidden = true; return; }
      var current = values.find(function (v) { return v.handle === handle; });
      var shown = values.slice(0, max);
      if (current && shown.indexOf(current) === -1) shown[shown.length - 1] = current;
      var extra = values.length - shown.length;

      var html = '';
      if (isPdp) {
        html += '<p class="chpo-swatches__label"><span>' + escapeHtml((group.option_name || 'Colour').replace('/', ' / ')) + ':</span> ' +
          '<strong data-current>' + escapeHtml(current ? current.option_value.replace('/', ' / ') : '') + '</strong></p>';
      }
      html += '<ul class="chpo-swatches__list" role="list">';
      shown.forEach(function (v) {
        var parts = v.option_value.split('/');
        var sel = v.handle === handle;
        html += '<li><a class="chpo-swatch' + (sel ? ' is-selected' : '') + '" href="/products/' + encodeURIComponent(v.handle) +
          '" title="' + escapeHtml(v.option_value) + '" aria-label="' + escapeHtml(v.option_value) + '"' +
          (sel ? ' aria-current="true"' : '') + ' data-handle="' + escapeHtml(v.handle) + '">' +
          splitSvg(parts[0], parts[1], sel && isPdp, false) + '</a></li>';
      });
      if (extra > 0) html += '<li class="chpo-swatches__more">+' + extra + '</li>';
      html += '</ul>';
      this.innerHTML = html;
      this.classList.add('is-ready');

      // On the product page, mark sold-out siblings so the slash shows.
      if (isPdp) this.markAvailability(values, handle);
    }

    markAvailability(values, handle) {
      var self = this;
      values.forEach(function (v) {
        if (v.handle === handle) return;
        fetch('/products/' + encodeURIComponent(v.handle) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p || p.available) return;
            var link = self.querySelector('a[data-handle="' + v.handle + '"]');
            if (!link) return;
            var parts = v.option_value.split('/');
            link.innerHTML = splitSvg(parts[0], parts[1], false, true);
            link.classList.add('is-sold-out');
            link.setAttribute('title', v.option_value + ' (sold out)');
          })
          .catch(function () {});
      });
    }
  }

  customElements.define('chpo-swatches', ChpoSwatches);
})();
